import stateCityDictionary, {
  formatName,
  urlifyName,
} from "../../constants/stateCityDictionary"

import { Anchor } from "../../app/components/anchor"
import PetStateCard from "./PetStateCard"
import PrimaryButton from "../../components/buttons/PrimaryButton"
import React from "react"

import { useRouter } from "next/router"

interface IRecentPetTransports {
  topExportShipments: any[]
  topImportShipments: any[]
  isState?: boolean
}

export default function RecentPetTransports({
  topExportShipments,
  topImportShipments,
}: IRecentPetTransports) {
  const router = useRouter()
  const { city, state } = router.query

  const formattedState = formatName(state as string)
  const urlifiedCity = city ? urlifyName(city as string) : ""

  const originalCity =
    stateCityDictionary[formattedState]?.cities.find(
      (dictCity) => urlifyName(dictCity) === urlifiedCity,
    ) ?? ""

  const formattedCity = originalCity ? formatName(originalCity) : ""
  const stateAbbrev = stateCityDictionary[formattedState]?.abbreviation ?? ""

  const currentLocation = formattedCity
    ? `${formattedCity}, ${stateAbbrev}`
    : formattedState

  const safelyFormattedCity = formattedCity
    ? `${formattedCity}, ${stateAbbrev}`
    : formattedState

  const recentlyFormattedCity = formattedCity
    ? `${formattedCity}`
    : formattedState

  return (
    <section className="w-full my-16 xl:my-32 flex flex-col items-center">
      <h3 className="max-w-prose mx-auto mb-16 font-medium text-blue7 text-4xl text-center">
        Recent {recentlyFormattedCity} pet transport deliveries from our
        marketplace
      </h3>

      <section className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div>
          <h3 className="mb-6 text-2xl text-center font-montserrat font-semibold">
            {safelyFormattedCity} to Other Cities
          </h3>
          {topExportShipments?.map((shipment, i) => (
            // @ts-ignore
            <PetStateCard
              key={`RecentPetTransports/topExportShipments/${i}`}
              // @ts-ignore
              {...shipment}
              type="export"
              currentLocation={currentLocation}
            />
          ))}
        </div>
        <div>
          <h3 className="mb-6 text-2xl text-center font-montserrat font-semibold">
            Other Cities to {safelyFormattedCity}
          </h3>
          {topImportShipments?.map((shipment, i) => (
            // @ts-ignore
            <PetStateCard
              key={`RecentPetTransports/topImportShipments/${i}`}
              // @ts-ignore
              {...shipment}
              type="import"
              currentLocation={currentLocation}
            />
          ))}
        </div>
      </section>

      <Anchor className="mt-16 mx-auto" href="/shipments/new/animals" passHref>
        <PrimaryButton className="mx-auto rounded-lg">
          Get Pet Transportation Quotes
        </PrimaryButton>
      </Anchor>
    </section>
  )
}
